<template>
  <div class="RichTextEdit">
    <MaterialPickModal
        :materialType="materialType"
        :show="showPickMaterial"
        @onConfirmPickMaterial="onConfirmPickMaterial"
    ></MaterialPickModal>
    <div
        style="
        border: 1px solid #ccc;
        height: 95%;
        display: flex;
        flex-direction: column;
      "
    >
      <Toolbar
          style="border-bottom: 1px solid #ccc; height: fit-content"
          :editor="editor"
          :defaultConfig="toolbarConfig"
          ref="toolbar"
          :mode="mode"
      />
      <Editor
          style="overflow-y: hidden; height: inherit"
          v-model="content"
          :defaultConfig="editorConfig"
          :mode="mode"
          @onCreated="onCreated"
      />
    </div>
    <div class="footer">
      <div v-show="permissionCode.has('assist:task:manager')">
        <el-button v-if="!selectNode.data.noEdit"
                   :disabled="disableSave"
                   style="width: 10vw; margin-top: 1vh"
                   type="primary"
                   @click="saveWiki"
        >保存
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import tenant from "../../api/tenant";
import {Editor, Toolbar} from "@wangeditor/editor-for-vue";
import {Boot} from "@wangeditor/editor";
import wikiCenter from "../../api/wikiCenter";
import attachmentModule from "@wangeditor/plugin-upload-attachment";
import InsertImageMenu from "./InsertImageMenu";
import InsertVideoMenu from "./InsertVideoMenu";
import {insertImage} from "./insertImageNode";
import {insertVideo} from "./insertVideoNode";

import MaterialPickModal from "@/pages/MaterialCenter/components/MaterialPickModal.vue";

Boot.registerModule(attachmentModule);

export default {
  name: "RichTextEdit",
  components: {Editor, Toolbar, MaterialPickModal},
  data() {
    return {
      showPickMaterial: {
        show: false
      },
      materialType: 'image',
      blankString: "<p><br></p>",
      taskId: null,
      material: [],
      editor: null,
      toolbar: null,
      content: "<p><br></p>",
      md5: null,
      disableSave: true,
      toolbarConfig: {
        toolbarKeys: [
          "headerSelect",
          "blockquote",
          "codeBlock",
          "|",
          "bold",
          "underline",
          "italic",
          {
            key: "group-more-style",
            title: "更多",
            iconSvg:
                '<svg viewBox="0 0 1024 1024">' +
                '<path d="M204.8 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path>' +
                '<path d="M505.6 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path>' +
                '<path d="M806.4 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path>' +
                "</svg>",
            menuKeys: ["through", "code", "sup", "sub", "clearStyle"],
          },
          "color",
          "bgColor",
          "|",
          "fontSize",
          "fontFamily",
          "lineHeight",
          "|",
          "bulletedList",
          "numberedList",
          "todo",
          {
            key: "group-justify",
            iconSvg:
                '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',
            title: "对齐",
            menuKeys: [
              "justifyLeft",
              "justifyRight",
              "justifyCenter",
              "justifyJustify",
            ],
          },
          {
            key: "group-indent",
            title: "缩进",
            iconSvg:
                '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>',
            menuKeys: ["indent", "delIndent"],
          },
          "|",
          "emotion",
          {
            key: "group-link",
            title: "附件",
            iconSvg:
                '<svg viewBox="0 0 1024 1024"><path d="M440.224 635.776a51.84 51.84 0 0 1-36.768-15.232c-95.136-95.136-95.136-249.92 0-345.056l192-192C641.536 37.408 702.816 12.032 768 12.032s126.432 25.376 172.544 71.456c95.136 95.136 95.136 249.92 0 345.056l-87.776 87.776a51.968 51.968 0 1 1-73.536-73.536l87.776-87.776a140.16 140.16 0 0 0 0-197.984c-26.432-26.432-61.6-40.992-99.008-40.992s-72.544 14.56-99.008 40.992l-192 192a140.16 140.16 0 0 0 0 197.984 51.968 51.968 0 0 1-36.768 88.768z"></path><path d="M256 1012a242.4 242.4 0 0 1-172.544-71.456c-95.136-95.136-95.136-249.92 0-345.056l87.776-87.776a51.968 51.968 0 1 1 73.536 73.536l-87.776 87.776a140.16 140.16 0 0 0 0 197.984c26.432 26.432 61.6 40.992 99.008 40.992s72.544-14.56 99.008-40.992l192-192a140.16 140.16 0 0 0 0-197.984 51.968 51.968 0 1 1 73.536-73.536c95.136 95.136 95.136 249.92 0 345.056l-192 192A242.4 242.4 0 0 1 256 1012z"></path></svg>',
            // menuKeys: ["insertLink", "uploadAttachment", "downloadAttachment"],
            menuKeys: ["uploadAttachment", "downloadAttachment"],
          },
          {
            key: "group-image",
            title: "图片",
            iconSvg:
                '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
            // menuKeys: ["yjPickImage", "insertImage", "uploadImage"],
            menuKeys: ["yjPickImage", "uploadImage"],
          },
          {
            key: "group-video",
            title: "视频",
            iconSvg:
                '<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>',
            // menuKeys: ["yjPickVideo", "insertVideo", "uploadVideo"],
            menuKeys: ["yjPickVideo", "uploadVideo"],
          },
          "insertTable",
          "divider",
          "|",
          "undo",
          "redo",
          "|",
          "fullScreen",
        ],
      },
      editorConfig: {
        placeholder: "请输入内容...",
        autoFocus: false,
        MENU_CONF: {}
        // readOnly: true,
      },
      mode: "default", // or 'simple'
    };
  },
  computed: {
    ...mapState("taskCenter", ["type", "currentNode", "selectNode"]),
    ...mapState("user", ["permissionCode"]),
  },
  watch: {
    currentNode: {
      handler(value) {
        if (!value.id) return;
        if (this.selectNode.level < 2) {
          this.editor.disable();
          this.disableSave = true;
        } else {
          this.editor.enable();
          this.disableSave = false;
          this.editor.focus();
        }

        this.editor.history.redos.length = 0;
        this.editor.history.undos.length = 0;
        this.editor.select({
          anchor: {path: [0, 0], offset: 0},
          focus: {path: [0, 0], offset: 0},
        });
        let md5 = this.$md5(this.content);
        if (this.md5 && this.md5 !== md5) {
          this.$confirm("您的内容改动还未保存，是否保存内容", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(
              () => {
                this.saveWiki().then(() => this.loadWiki());
              },
              () => {
                this.loadWiki();
              }
          );
        } else {
          this.loadWiki();
        }
      },
    },
  },
  methods: {
    onConfirmPickMaterial(item) {
      if (this.materialType == 'image') {
        insertImage(this.editor, item.url);
      } else {
        insertVideo(this.editor, item.url);
      }
    },
    onConfirmInsertImage() {
      this.showPickMaterial.show = true;
    },
    onConfirmInsertVideo() {
      this.showPickMaterial.show = true;
    },
    onCreated(editor) {
      var that = this;
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.editor.disable();
      let _self = this;
      this.editor.getConfig().MENU_CONF.uploadImage = {
        allowedFileTypes: ["image/*"],
        async customUpload(file, insertFn) {
          _self.uploadFiles(file, (m) => {
            _self.material.push(m);
            insertFn(m.url, file.name);
          });
        },
      };
      this.editor.getConfig().MENU_CONF.uploadVideo = {
        allowedFileTypes: ["video/*"],
        async customUpload(file, insertFn) {
          _self.uploadFiles(file, (m) => {
            _self.material.push(m);
            insertFn(m.url);
          });
        },
      };
      this.editor.getConfig().MENU_CONF.uploadAttachment = {
        server: "/api/upload",
        allowedFileTypes: ["*/*"],
        async customUpload(file, insertFn) {
          _self.uploadFiles(file, (m) => {
            m.supportDownload = true;
            _self.material.push(m);
            insertFn(file.name, m.url);
          });
        },
      };

      this.editor.on('on-select-image-material', () => {
        that.materialType = 'image';
        that.onConfirmInsertVideo();
      })
      this.editor.on('on-select-video-material', () => {
        that.materialType = 'video';
        that.onConfirmInsertVideo();
      })

      const pickImageMenuConf = {
        key: 'yjPickImage', // 定义 menu key ：要保证唯一、不重复（重要）
        factory() {
          return new InsertImageMenu() // 替换为你菜单的 class
        },
      }
      const pickVideoMenuConf = {
        key: 'yjPickVideo', // 定义 menu key ：要保证唯一、不重复（重要）
        factory() {
          return new InsertVideoMenu(); // 替换为你菜单的 class
        },
      }
      // 注册菜单
      Boot.registerMenu(pickImageMenuConf)
      Boot.registerMenu(pickVideoMenuConf)
    },
    async saveWiki() {
      let content = this.content;
      let $md5 = this.$md5(this.content);
      if (!this.taskId) {
        this.$message.warning("请先选中任务再保存");
        return;
      }
      this.material.forEach((m) => {
        if (m.id) {
          content = content.replaceAll(m.url, "{material:" + m.id + "}");
        } else {
          content = content.replaceAll(m.url, m.filename);
        }
      });
      let text = this.editor.getText();
      await wikiCenter.saveWiki(
          content,
          this.material,
          this.taskId,
          text,
          this.currentNode.name
      );
      this.md5 = $md5;
      this.$message.success("保存成功");
      await this.loadWiki();
    },
    uploadFiles(file, call) {
      tenant
          .generalUploadUrl({
            contentType: file.type,
          })
          .then((res) => {
            let data = res.data;
            const name = encodeURIComponent(file.name);
            let objectURL = URL.createObjectURL(file);
            const obj = {
              "Content-Disposition": "attachment;filename=" + '"' + name + '"',
              "Content-Type": file.type,
            };
            let m = {
              filename: data.filename,
              url: objectURL,
              mimeType: file.type,
            };
            this.$axios({
              url: data.url,
              withCredentials: false,
              method: "put",
              isUpload: true,
              data: file,
              headers: obj,
            })
                .then(() => {
                  call(m);
                })
                .catch(() => {
                  this.$message.error("上传失败，请重新上传");
                });
          });
    },
    async loadWiki() {
      let currentNode = this.currentNode;

      let res = await wikiCenter.getWiki(currentNode.id);
      let content = res.data.content || this.blankString;
      this.material = res.data.material || [];
      this.taskId = currentNode.id;
      this.material &&
      this.material.forEach((m) => {
        content = content.replaceAll("{material:" + m.id + "}", m.url);
      });
      // 清空操作历史
      this.editor.setHtml(content);
      this.md5 = this.$md5(content);
    },
  },
  mounted() {
  },
  beforeDestroy() {
    let md5 = this.$md5(this.content);
    if (this.md5 && this.md5 !== md5) {
      this.$alert("您的内容改动还未保存，是否保存内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.saveWiki();
      });
    }
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss">
.RichTextEdit {
  height: 100%;

  .footer {
    text-align: center;
    height: 5%;
  }
}
</style>
